import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, Signal, computed, input, output } from '@angular/core';

import { BlockDirective, ElemDirective, ModDirective } from '@rt-tools/core';

export type IAppLocale = 'ru' | 'en';

const BEM_BLOCK: string = 'sc-language-switcher';

@Component({
    selector: 'sc-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrl: './language-switcher.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        // rt-tools
        BlockDirective,
        ElemDirective,
        ModDirective,
    ],
    host: {
        class: BEM_BLOCK,
    },
})
export class LanguageSwitcherComponent {
    protected readonly isRu: Signal<boolean> = computed(() => this.currentLocale() === 'ru');
    protected readonly isEn: Signal<boolean> = computed(() => this.currentLocale() === 'en');

    public readonly currentLocale: InputSignal<string> = input.required<string>();
    public readonly ruHref: InputSignal<string> = input.required<string>();
    public readonly enHref: InputSignal<string> = input.required<string>();

    public readonly localeSelected: OutputEmitterRef<IAppLocale> = output<IAppLocale>();

    // The link navigates by itself; a click on the language already chosen is cancelled, so the page stays.
    protected onSelect(event: MouseEvent, target: IAppLocale): void {
        const currentLang: IAppLocale = this.isEn() ? 'en' : 'ru';
        if (target === currentLang) {
            event.preventDefault();
            return;
        }
        this.localeSelected.emit(target);
    }
}
